import { Badge } from '../../ui/Labels';
import { useStrings } from '../../tenant/TenantProvider';

const TONES = { live: 'success', upcoming: 'accent', ended: 'warning', finalized: undefined, cancelled: 'danger', draft: undefined };

export function ContestStateBadge({ state }) {
  const t = useStrings();
  return (
    <Badge tone={TONES[state]} dot={state === 'live'}>
      {t(`contests.states.${state}`, { fallback: state })}
    </Badge>
  );
}
